import React from 'react'
import { DeprecatedBrokerCarrierAgreementForm } from 'apps/fleet-planner/components/activation/DeprecatedBrokerCarrierAgreementForm'
import { DeprecatedDocumentsUpload } from 'apps/fleet-planner/components/activation/DeprecatedDocumentsUpload'
import { BrokerCarrierAgreementForm } from './BrokerCarrierAgreementForm'
import { ProvideInsurance } from './ProvideInsurance'
import ProvideSafetyLetter from './ProvideSafetyLetter'

export const DEPRECATED_STEPS = {
  bca: {
    component: <DeprecatedBrokerCarrierAgreementForm key='broker-carrier-agreement' />,
    step: 1,
  },
  documents: { component: <DeprecatedDocumentsUpload key='documents-upload' />, step: 2 },
}

export type TStep = keyof typeof DEPRECATED_STEPS

export const STEPS = {
  bca: {
    component: <BrokerCarrierAgreementForm key='broker-carrier-agreement' />,
    step: 1,
  },
  insurance: {
    component: <ProvideInsurance key='provider-insurance' />,
    step: 2,
  },
  documents: { component: <DeprecatedDocumentsUpload key='documents-upload' />, step: 3 },
  safetyLetter: {
    component: <ProvideSafetyLetter key='safety-letter' />,
    step: 4,
  },
}
